import React, { Component } from "react";

import {
  Card,
  Button,
  Table,
  Tooltip,
  Select,
  Input,
  BackTop,
  Modal,
  Tag,
  message,
} from "antd";

import { connect } from "react-redux";
import {
  req_page_tqa_worker,
  req_downloadfile_tqa_worker,
  req_list_tqa_department_log,
} from "../../api";

import {
  API_BASE,
  PAGE_SIZE,
  SORT_FIELD_NAME,
  SORT_UP_DOWN,
} from "../../utils/contrains";
import { usrRole } from "../../utils/dataUtil";
import { getNowAcademicYear } from "../../utils/dateUtil";

import WorkerModifyModal from "./manage-worker-modify-modal";
import HistoryLogsDepartmentModal from "./history-logs-department-modal";
import SchoolJudgeModifyAModal from "./school-judge-modify-a-modal";
import SchoolJudgeModifyBModal from "./school-judge-modify-b-modal";

class QualityManageWorkerList extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  state = {
    deviceWidth: 0,
    loading: false,
    userLevel: "NORMAL",
    items: [],
    item: {},
    pagination: {
      current: 1,
      pageSize: PAGE_SIZE,
      total: 0,
    },
    columnSort: SORT_FIELD_NAME,
    orderBy: SORT_UP_DOWN,
    searchField: "NONE",
    searchValue: "",
    filterStatus: "",

    domnloadFile: "",
    academicYear: getNowAcademicYear(new Date()),
    isShowModal: false,
    isEditModal: false,
    isLogModal: false,
    isEditSchAModal: false,
    isEditSchBModal: false,
    isEditDepartAModal: false,
    isEditDepartBModal: false,
    logs: [],
  };

  UNSAFE_componentWillMount() {
    this.init_columns();
  }

  componentDidMount() {
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
    this.api_page_items(1);
  }

  // 遠端數據處理 //////////////////////////////////////////////

  api_page_items = (current) => {
    this.current = current; // 保存當前頁，給其他方法可看到
    const { pageSize } = this.state.pagination;
    const {
      searchField,
      searchValue,
      columnSort,
      orderBy,
      filterStatus,
      academicYear,
    } = this.state;
    const { token, userCode, role } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });

    this.api_page_run(
      userCode,
      userLevel,
      current,
      pageSize,
      columnSort,
      orderBy,
      searchField,
      searchValue,
      filterStatus,
      academicYear,
      token
    );
  };

  api_page_run = async (
    userCode,
    userLevel,
    current,
    pageSize,
    columnSort,
    orderBy,
    searchField,
    searchValue,
    filterStatus,
    academicYear,
    token
  ) => {
    this.setState({ loading: true });
    const result = await req_page_tqa_worker(
      userCode,
      userLevel,
      current,
      pageSize,
      columnSort,
      orderBy,
      searchField,
      searchValue,
      filterStatus,
      academicYear,
      token
    );
    //console.log(result);
    if (result.total > 0) {
      const { total } = result;
      const items = result.data;
      const pagination = {
        current: this.current,
        pageSize: this.state.pagination.pageSize,
        total,
      };
      this.setState({ items, pagination });
    } else {
      const items = [];
      const pagination = {
        current: 1,
        pageSize: this.state.pagination.pageSize,
        total: 0,
      };
      this.setState({ items, pagination });
    }
    this.setState({ loading: false });
  };

  api_downloadfile_items = async () => {
    const { userLevel, searchField, searchValue, filterStatus, academicYear } =
      this.state;
    const { token, userCode } = this.props.user;

    // download file data
    const fileUrl = await req_downloadfile_tqa_worker(
      userCode,
      userLevel,
      searchField,
      searchValue,
      filterStatus,
      academicYear,
      token
    );

    // download file link
    let a = document.createElement("a");
    a.href = API_BASE + fileUrl;
    a.target = "_blank";
    a.download = "品保作業人員清單";
    a.click();
  };

  api_downloadfile_manual = async (fileUrl) => {
    // download file link
    console.log(fileUrl);
    let a = document.createElement("a");
    a.href = API_BASE + fileUrl;
    a.target = "_blank";
    a.download = "清單";
    a.click();
  };

  api_page_logs = async (item) => {
    const { academicYear } = this.state;
    const { DepartmentCode } = item;
    const { token, role } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });

    const result = await req_list_tqa_department_log(
      academicYear,
      DepartmentCode,
      token
    );
    if (result.total > 0) {
      const logs = result.data;
      this.setState({ logs }, () => {
        this.setState({ isLogModal: true });
      });
    } else {
      const logs = [];
      message.info("查無資料");
      this.setState({ logs });
    }
  };

  // 數據配置設定 //////////////////////////////////////////////

  init_columns = () => {
    const academicYear = getNowAcademicYear(new Date());
    this.setState({ academicYear });
    this.columns = [
      {
        title: "分類",
        width: 20,
        responsive: ["md"],
        render: (item) => {
          const { WorkTypeCode } = item;
          return (
            <div className="text-center">
              <Tag color={this.style_switch_color_tag(WorkTypeCode)}>
                {this.style_switch_text_tag(WorkTypeCode)}
              </Tag>
            </div>
          );
        },
      },
      {
        title: "學年度",
        dataIndex: "AcademicYear",
        width: 20,
        responsive: ["md"],
      },
      {
        title: "單位",
        dataIndex: "DepartmentName",
        width: 50,
        render: (field) => {
          return (
            <div>
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "品保老師",
        width: 40,
        responsive: ["md"],
        render: (item) => {
          const { AuthorName } = item;
          return (
            <div className="text-center">
              <span style={{ fontSize: "1.3em" }}> {AuthorName}</span>
              <button
                type="button"
                className="btn btn-outline-dark btn-sm"
                style={{ marginLeft: "2px" }}
                onClick={() => this.handle_show_ui_modal("edit", item)}
              >
                <i className="fa fa-cog"></i>
                <span style={{ marginLeft: "2px" }}>指派</span>
              </button>
            </div>
          );
        },
      },
      {
        title: "進度",
        dataIndex: "RecordStatus",
        width: 20,
        render: (field) => {
          //const { board } = englishactivity
          return (
            <div className="text-center">
              <Tag color={this.style_switch_schedule_color(field)}>
                {this.style_switch_schedule_text(field)}
              </Tag>
            </div>
          );
        },
      },
      {
        title: "",
        dataIndex: "",
        width: 65,
        render: (item) => {
          const {
            RecordStatus,
            WorkTypeCode,
            SchoolJudgeCodeA,
            SchoolJudgeStatusA,
            SchoolJudgeCodeB,
            SchoolJudgeStatusB,
            DepartmentJudgeFixStatus,
          } = item;
          return (
            <>
              {" "}
              <button
                type="button"
                className="btn btn-outline-dark btn-sm"
                onClick={() => this.handle_show_ui_modal("log", item)}
              >
                <i className="fa fa-align-justify"></i>
                <span style={{ marginLeft: "2px" }}>歷程</span>
              </button>
              {RecordStatus === "REVIEW" ? (
                <>
                  {WorkTypeCode === "A" ? (
                    <>
                      <button
                        type="button"
                        className={
                          SchoolJudgeCodeA === ""
                            ? "btn btn-outline-dark btn-sm"
                            : "btn btn-outline-info btn-sm"
                        }
                        onClick={() =>
                          this.handle_show_ui_modal("edit_judge_sch_a", item)
                        }
                        disabled={SchoolJudgeStatusA === "SUBMIT"}
                      >
                        <i className="fa fa-user-circle"></i>
                        <span style={{ marginLeft: "2px" }}>校評一</span>
                      </button>
                      <button
                        type="button"
                        className={
                          SchoolJudgeCodeB === ""
                            ? "btn btn-outline-dark btn-sm"
                            : "btn btn-outline-info btn-sm"
                        }
                        onClick={() =>
                          this.handle_show_ui_modal("edit_judge_sch_b", item)
                        }
                        disabled={SchoolJudgeStatusB === "SUBMIT"}
                      >
                        <i className="fa fa-user-circle"></i>
                        <span style={{ marginLeft: "2px" }}>校評二</span>
                      </button>
                    </>
                  ) : (
                    ""
                  )}
                  {WorkTypeCode === "B" ? (
                    <>
                      <button
                        type="button"
                        className={
                          SchoolJudgeCodeA === ""
                            ? "btn btn-outline-dark btn-sm"
                            : "btn btn-outline-info btn-sm"
                        }
                        onClick={() =>
                          this.handle_show_ui_modal("edit_judge_sch_a", item)
                        }
                        disabled={SchoolJudgeStatusA === "SUBMIT"}
                      >
                        <i className="fa fa-user-circle"></i>
                        <span style={{ marginLeft: "2px" }}>校評一</span>
                      </button>
                      <button
                        type="button"
                        className={
                          SchoolJudgeCodeB === ""
                            ? "btn btn-outline-dark btn-sm"
                            : "btn btn-outline-info btn-sm"
                        }
                        onClick={() =>
                          this.handle_show_ui_modal("edit_judge_sch_b", item)
                        }
                        disabled={SchoolJudgeStatusB === "SUBMIT"}
                      >
                        <i className="fa fa-user-circle"></i>
                        <span style={{ marginLeft: "2px" }}>校評二</span>
                      </button>
                    </>
                  ) : (
                    ""
                  )}
                  {WorkTypeCode === "C" &&
                  DepartmentJudgeFixStatus === "FINISH" ? (
                    <>
                      <button
                        type="button"
                        className={
                          SchoolJudgeCodeA === ""
                            ? "btn btn-outline-dark btn-sm"
                            : "btn btn-outline-info btn-sm"
                        }
                        onClick={() =>
                          this.handle_show_ui_modal("edit_judge_sch_a", item)
                        }
                        disabled={SchoolJudgeStatusA === "SUBMIT"}
                      >
                        <i className="fa fa-user-circle"></i>
                        <span style={{ marginLeft: "2px" }}>校評一</span>
                      </button>
                      <button
                        type="button"
                        className={
                          SchoolJudgeCodeB === ""
                            ? "btn btn-outline-dark btn-sm"
                            : "btn btn-outline-info btn-sm"
                        }
                        onClick={() =>
                          this.handle_show_ui_modal("edit_judge_sch_b", item)
                        }
                        disabled={SchoolJudgeStatusB === "SUBMIT"}
                      >
                        <i className="fa fa-user-circle"></i>
                        <span style={{ marginLeft: "2px" }}>校評二</span>
                      </button>
                    </>
                  ) : (
                    ""
                  )}
                  {WorkTypeCode === "D" &&
                  DepartmentJudgeFixStatus === "FINISH" ? (
                    <>
                      <button
                        type="button"
                        className={
                          SchoolJudgeCodeA === ""
                            ? "btn btn-outline-dark btn-sm"
                            : "btn btn-outline-info btn-sm"
                        }
                        onClick={() =>
                          this.handle_show_ui_modal("edit_judge_sch_a", item)
                        }
                        disabled={SchoolJudgeStatusA === "SUBMIT"}
                      >
                        <i className="fa fa-user-circle"></i>
                        <span style={{ marginLeft: "2px" }}>校評一</span>
                      </button>
                      <button
                        type="button"
                        className={
                          SchoolJudgeCodeB === ""
                            ? "btn btn-outline-dark btn-sm"
                            : "btn btn-outline-info btn-sm"
                        }
                        onClick={() =>
                          this.handle_show_ui_modal("edit_judge_sch_b", item)
                        }
                        disabled={SchoolJudgeStatusB === "SUBMIT"}
                      >
                        <i className="fa fa-user-circle"></i>
                        <span style={{ marginLeft: "2px" }}>校評二</span>
                      </button>
                    </>
                  ) : (
                    ""
                  )}
                </>
              ) : (
                ""
              )}
              {RecordStatus === "DONE" ? (
                <button
                  type="button"
                  className="btn btn-outline-success btn-sm"
                  onClick={() =>
                    this.handle_show_ui_modal("DOWNLOAD_MANUAL", item)
                  }
                >
                  <i className="fas fa-cloud-download-alt"></i>
                  <span style={{ marginLeft: "2px" }}>下載</span>
                </button>
              ) : (
                ""
              )}
            </>
          );
        },
      },
    ];
  };

  style_switch_text_tag(column) {
    let ans = "其他";
    switch (column) {
      case "A":
        ans = "學院"; // 學院
        break;
      case "B": // 中心
        ans = "中心";
        break;
      case "C":
        ans = "學系"; // 學系
        break;
      case "D":
        ans = "碩班"; //碩班
        break;
      default:
        // OTHER
        break;
    }
    return ans;
  }

  style_switch_color_tag(column) {
    let ans = "其他";
    switch (column) {
      case "A":
        ans = "#87d068"; // 學院
        break;
      case "B": // 中心
        ans = "#108ee9";
        break;
      case "C": // 學系
        ans = "magenta";
        break;
      case "D":
        ans = "#f50"; // 碩班
        break;
      default:
        ans = "gold";
        break;
    }
    return ans;
  }

  style_switch_schedule_text(column) {
    let ans = "其他";
    switch (column) {
      case "INIT":
        ans = "初始化";
        break;
      case "EDIT":
        ans = "規劃中";
        break;
      case "CHECK":
        ans = "簽核中";
        break;
      case "VETO":
        ans = "已退件";
        break;
      case "REVIEW":
        ans = "已送審";
        break;
      case "SUBMIT":
        ans = "已送審";
        break;
      case "DONE":
        ans = "已完成";
        break;
      case "CANCEL":
        ans = "已註銷";
        break;
      default:
        break;
    }
    return ans;
  }

  style_switch_schedule_color(column) {
    let ans = "#FFFFFF";
    switch (column) {
      case "INIT":
        ans = "#33ECFF";
        break;
      case "EDIT":
        ans = "#108EE9";
        break;
      case "CHECK":
        ans = "#FF7300";
        break;
      case "VETO":
        ans = "#808080";
        break;
      case "REVIEW":
        ans = "#AF982C";
        break;
      case "SUBMIT":
        ans = "#AF982C";
        break;
      case "DONE":
        ans = "#87D068";
        break;
      case "CANCEL":
        ans = "#FF0000";
        break;
      default:
        break;
    }
    return ans;
  }

  // 操作互動處理 //////////////////////////////////////////////

  resize() {
    this.setState({ deviceWidth: window.innerWidth });
  }

  handle_page_size_change = (current, size) => {
    //console.log(size)
    this.setState(
      {
        pagination: {
          current: current,
          pageSize: size,
        },
      },
      () => {
        this.api_page_items(current);
      }
    );
  };

  handle_table_change = (pagination, filters, sorter, extra) => {
    if (filters) {
      const status = [...Object.values(filters).filter(Boolean)][0];
      if (status) {
        this.setState({ filterStatus: status }, () => {
          this.api_page_items(pagination.current);
        });
      } else {
        this.setState({ filterStatus: "" }, () => {
          this.api_page_items(pagination.current);
        });
      }
    } else {
      this.api_page_items(pagination.current);
    }
  };

  handle_data_refresh = () => {
    this.api_page_items(this.current);
  };

  handle_show_ui_modal = (modal, item) => {
    switch (modal) {
      case "view":
        this.setState({ isShowModal: true, item });
        break;
      case "edit":
        this.setState({ isEditModal: true, item });
        break;
      case "edit_judge_sch_a":
        //console.log(item);
        this.setState({ isEditSchAModal: true, item });
        break;
      case "edit_judge_sch_b":
        this.setState({ isEditSchBModal: true, item });
        break;
      case "edit_judge_depart_a":
        this.setState({ isEditDepartAModal: true, item });
        break;
      case "edit_judge_depart_b":
        this.setState({ isEditDepartBModal: true, item });
        break;
      case "log":
        this.api_page_logs(item);
        break;
      case "download":
        this.api_downloadfile_items();
        break;
      case "DOWNLOAD_MANUAL":
        const { WorkManualFileUrl } = item;
        this.api_downloadfile_manual(WorkManualFileUrl);
        break;
      default:
    }
  };

  handle_ui_field_change = (target_key, target_field, e) => {
    const value = e.target.value;
    const item = {
      activityNid: target_key,
      setPoints: value,
      condition: target_field,
    };
    //console.log(target_key)
    this.api_modify_item(item);
  };

  /////////////////////////////////////////////////////////////

  render() {
    const {
      loading,
      item,
      logs,
      items,
      pagination,
      searchField,
      searchValue,
      academicYear,
      isEditModal,
      isEditSchAModal,
      isEditSchBModal,
      isEditDepartAModal,
      isEditDepartBModal,
      isLogModal,
    } = this.state;
    const title = (
      <>
        <Input
          placeholder="學年"
          style={{ width: 55, margin: "0 5px", backgroundColor: "LightYellow" }}
          value={academicYear}
          onChange={(event) =>
            this.setState({ academicYear: event.target.value })
          }
        />
        <Select
          value={searchField}
          style={{ width: 120, backgroundColor: "LightCyan" }}
          onChange={(value) => this.setState({ searchField: value })}
        >
          <Select.Option value="NONE">搜索條件</Select.Option>
          <Select.Option value="DepartmentName">單位</Select.Option>
        </Select>
        <Input
          placeholder="關鍵字"
          style={{ width: 80, margin: "0 5px", backgroundColor: "LightYellow" }}
          value={searchValue}
          onChange={(event) =>
            this.setState({ searchValue: event.target.value })
          }
        />
        <Button type="primary" onClick={() => this.api_page_items(1)}>
          <i className="fas fa-search element-hidden"></i>
          <span style={{ marginLeft: "4px" }}>查詢</span>
        </Button>{" "}
        <Tooltip placement="top" title="重新整理">
          <Button type="primary" onClick={() => this.handle_data_refresh()}>
            <i className="fas fa-sync-alt"></i>
          </Button>
        </Tooltip>
        <Button
          type="primary"
          onClick={() => this.handle_show_ui_modal("download", {})}
          style={{ marginLeft: "4px" }}
        >
          <i className="fas fa-cloud-download-alt element-hidden"></i> 下載
        </Button>
      </>
    );
    return (
      <Card title={title}>
        <Table
          bordered
          scroll={{ y: 480 }}
          loading={loading}
          rowKey="activityNid"
          dataSource={items}
          onChange={this.handle_table_change}
          pagination={{
            ...pagination,
            responsive: true,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: [5, 10, 20, 50, 100],
            onShowSizeChange: this.handle_page_size_change,
          }}
          columns={this.columns}
        />
        <Modal
          destroyOnClose={true}
          visible={isEditModal}
          width={"80%"}
          onOk={() => {
            this.setState({ isEditModal: false });
            this.handle_data_refresh();
          }}
          onCancel={() => {
            this.setState({ isEditModal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <WorkerModifyModal worker={item} />
        </Modal>
        <Modal
          destroyOnClose={true}
          visible={isLogModal}
          width={"600px"}
          onOk={() => {
            this.setState({ isLogModal: false });
          }}
          onCancel={() => {
            this.setState({ isLogModal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <HistoryLogsDepartmentModal logs={logs} />
        </Modal>
        <Modal
          destroyOnClose={true}
          visible={isEditSchAModal}
          width={"60%"}
          onOk={() => {
            this.setState({ isEditSchAModal: false });
            this.handle_data_refresh();
          }}
          onCancel={() => {
            this.setState({ isEditSchAModal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <SchoolJudgeModifyAModal worker={item} />
        </Modal>
        <Modal
          destroyOnClose={true}
          visible={isEditSchBModal}
          width={"60%"}
          onOk={() => {
            this.setState({ isEditSchBModal: false });
            this.handle_data_refresh();
          }}
          onCancel={() => {
            this.setState({ isEditSchBModal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <SchoolJudgeModifyBModal worker={item} />
        </Modal>
        <Modal
          destroyOnClose={true}
          visible={isEditDepartAModal}
          width={"60%"}
          onOk={() => {
            this.setState({ isEditDepartAModal: false });
            this.handle_data_refresh();
          }}
          onCancel={() => {
            this.setState({ isEditDepartAModal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <WorkerModifyModal worker={item} />
        </Modal>
        <Modal
          destroyOnClose={true}
          visible={isEditDepartBModal}
          width={"60%"}
          onOk={() => {
            this.setState({ isEditDepartBModal: false });
            this.handle_data_refresh();
          }}
          onCancel={() => {
            this.setState({ isEditDepartBModal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <WorkerModifyModal worker={item} />
        </Modal>
        <BackTop visibilityHeight="80" />
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(QualityManageWorkerList);
